/**
 * Canonical, NON-SECRET Cardless service origins, by environment.
 *
 * These hosts are public and well-known — they must NOT be stored in encrypted config.
 * Only true secrets (e.g. OAuth client credentials) belong in web-conf. Any app or
 * tool that constructs an `ApiClient` / `AdminApiClient` / `AuthClient` should resolve
 * its base URLs from here so there is one discoverable source of truth.
 *
 * Convention (mirrors the asset-host logic in `@cardlesshq/constants`): production
 * uses the bare domain; every other environment uses the `-staging` domain.
 */
const getCardlessDomain = (env) => `cardless${env === 'production' ? '' : '-staging'}.com`;
/** Origin of the Cardless API — both member and `/transactions/admin/*` endpoints */
const getApiBaseUrl = (env) => `https://api.${getCardlessDomain(env)}`;
/** Origin of the Cardless auth (OAuth) API */
const getAuthBaseUrl = (env) => `https://auth.${getCardlessDomain(env)}`;
/** Origin of the Cardless VGS API */
const getVgsBaseUrl = (env) => `https://vgs.${getCardlessDomain(env)}`;
/** Origin of the Cardless mobile force upgrade API */
const getMobileForceUpgradeBaseUrl = (env) => `https://mobile-force-upgrade.${getCardlessDomain(env)}`;
/** Origin of Cardless Member Web (legacy servicing) */
const getMemberWebBaseUrl = (env) => `https://app.${getCardlessDomain(env)}`;
/** Origin of Embedded Web (sunrise) */
const getEmbeddedWebBaseUrl = (env) => `https://embedded.${getCardlessDomain(env)}`;
/** Origin of legacy account web (points-transfer microsite) */
const getAccountWebBaseUrl = (env) => `https://account.${getCardlessDomain(env)}`;
/** Origin of legal docs (cardholder agreements, disclosures, PDFs) */
const getLegalBaseUrl = (env) => `https://legal.${getCardlessDomain(env)}`;
/** Origin of marketing website (b2b) */
const getMarketingWebsiteBaseUrl = (env) => `https://www.${getCardlessDomain(env)}`;
/** Origin of the partner console */
const getPartnerConsoleBaseUrl = (env) => `https://developers.${getCardlessDomain(env)}`;
/** Origin of Cardless Console — on `crdls`, not the `cardless` domain */
const getCardlessConsoleBaseUrl = (env) => `https://console.crdls${env === 'production' ? '' : '-staging'}.com`;
/** All canonical Cardless service base URLs for an environment */
const getCardlessHosts = (env) => ({
    accountWeb: getAccountWebBaseUrl(env),
    api: getApiBaseUrl(env),
    auth: getAuthBaseUrl(env),
    embeddedWeb: getEmbeddedWebBaseUrl(env),
    legal: getLegalBaseUrl(env),
    memberWeb: getMemberWebBaseUrl(env),
    mobileForceUpgrade: getMobileForceUpgradeBaseUrl(env),
    vgs: getVgsBaseUrl(env),
    www: getMarketingWebsiteBaseUrl(env),
});
export { getAccountWebBaseUrl, getApiBaseUrl, getAuthBaseUrl, getCardlessConsoleBaseUrl, getCardlessDomain, getCardlessHosts, getEmbeddedWebBaseUrl, getLegalBaseUrl, getMarketingWebsiteBaseUrl, getMemberWebBaseUrl, getMobileForceUpgradeBaseUrl, getPartnerConsoleBaseUrl, getVgsBaseUrl, };
